import { Button, Card, Col, Input, Modal, Row } from "antd";
import { grayheader, cardmargin } from "../../CSSReferences";
import logo from '../../vodin_logo/image/Anima_logo.png';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from '../../../intl-compat';
import { Component } from "react";
import { VodinDownload } from "../../VodinDownload/VodinDownload";
import { Link } from "react-router-dom";
import { RESET_PAGE } from "../../PasswortZuruecksetzen/reset_logic";

export interface LocalProps{
    id:string;
    url:string;
    loginuser:string;
    lpw: string,
    loginstatus:boolean;

  onSubmit: (data:string, password:string) => void;
  onLogout: () => void;
  onSendPWReset: (user:string) => void;
  onValueChange:(data:string, parameter:string) => void;
}

interface InnerState{modalvis:boolean}

  const makeString = (amount:number): string => {
    let outString: string = '';
    let inOptions: string = 'abcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < amount; i++) {
      outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
    }

    return outString;
  }


  class LoginView extends Component<LocalProps& {intl:any},InnerState> 
  {
      constructor(props:LocalProps& {intl:any}){
        super(props);
        this.state = {
          modalvis: false,
        };
      }

    componentDidMount(){
    //  setTimeout(() => {
    //    if (this.props.loginstatus == false)
    //    { 
    //     console.log("killmelogin");
    //      this.props.onForceLogout();
    //    }
    //  }, 1000);
       
       // this.props.onButtonClicked();
     }

  onSubmit = ()  => {
    this.props.onSubmit(this.props.loginuser, this.props.lpw.toString());
  }
  onLogout= () =>
  {
    this.props.onLogout();
  }
  setModal1Visible=(set:boolean) => {
    this.setState({modalvis:set})
  }
  // Asks for a one-time key; the modal stays open so the answer and the way
  // to the key page are in view.
  SendPWReset=(user:string) => {
    this.props.onSendPWReset(user);
  }
  ChangeUsername=(data:any) => {
    this.props.onValueChange(data.target.value, "username");
  }
  ChangePassword=(data:any) => {
    this.props.onValueChange(data.target.value, "password");
  }
  render(){
  
  if (this.props.loginstatus === false)
  {
return (
  <Row gutter={16}>
      <Col span={8}></Col>
      <Col span={8}>
    <Card style={cardmargin} hoverable cover={
        <Row gutter={16}>
          <Col span={7}></Col>
          <Col span={10}>    
          <img 
            alt="Logo"
            width={"100%"}      
            src={logo}
            style={{ margin: '10%'}}
          /> 
          </Col>
          <Col span={7}></Col>
          </Row> } styles={{ header: grayheader }}>     
        <Row gutter={16}>
        <Col span={8}>
         
        <label>	<FormattedMessage id="login:view:Username" defaultMessage="Username" /> 
 </label>
        </Col>
        <Col span={8}>
        <Input name="username" placeholder={(this.props.intl.formatMessage({id:"Username", defaultMessage:"Username"}))} onChange={this.ChangeUsername} />

        {/* <input placeholder="Username" {...register("Username")} /> */}
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}>
        <label>	<FormattedMessage id="Login:view:Password" defaultMessage="Password" /> 
 </label>
        </Col>
        <Col span={8}>
        {/* include validation with required or other standard HTML validation rules */}
        <Input name="password"  type="password" placeholder={(this.props.intl.formatMessage({id:"Password", defaultMessage:"Password"}))} onChange={this.ChangePassword} />

        {/* <input type="password" placeholder="Password" {...register("Password", { required: true })} /> */}
        {/* errors will return when field validation fails  */}
        {/* {errors.Password && <span><FormattedMessage id="fieldrequired" defaultMessage="This field is required" /></span>} */}
        </Col>
        </Row>
        <Row gutter={16}>
        <Col span={8}></Col>
        <Col span={8}>
        <Button id="LoginButton" onClick={() => this.onSubmit()}>{(this.props.intl.formatMessage({id:"Login", defaultMessage:"Login"}))}</Button>
        <Button id="ForgotPassword" onClick={() => this.setModal1Visible(true)}>{(this.props.intl.formatMessage({id:"ForgotPassword", defaultMessage:"Forgot Password"}))}</Button>
        </Col>
        </Row>
      </Card>
      <VodinDownload />
    </Col>
    <Col span={8}>
    <Modal
          title="Request Password Reset"
          style={{ top: 20 }}
          open={this.state.modalvis}
          onCancel={() => this.setModal1Visible(false)}
          footer={null}
        >
          <p>A one-time key to set a new password goes to the e-mail address of the account. / Ein Einmal-Schlüssel zum Setzen eines neuen Passworts geht an die E-Mail-Adresse des Kontos.</p>
          <p><Input name="recovery username" placeholder={(this.props.intl.formatMessage({id:"Username", defaultMessage:"Username"}))} onChange={this.ChangeUsername} /></p>
          <p><Button type="primary" id="SendResetKey" onClick={() => this.SendPWReset(this.props.loginuser)}>{(this.props.intl.formatMessage({id:"SendResetKey", defaultMessage:"Send key"}))}</Button></p>
          <p><Link to={RESET_PAGE} id="HaveRecoveryKey">{(this.props.intl.formatMessage({id:"HaveRecoveryKey", defaultMessage:"I have a recovery key"}))}</Link></p>
        </Modal>
    </Col>
    </Row>
    )
  }
  else
  {
    return (
      <Row gutter={16}>
          <Col span={8}></Col>
          <Col span={8}>
        <Card style={cardmargin} hoverable cover={
            <Row gutter={16}>
              <Col span={8}></Col>
              <Col span={10}>    
              <img 
                alt="Logo"
                width={"100%"}      
                src={logo}
                style={{ margin: '10%'}}
              /> 
              </Col>
              <Col span={8}></Col>
              </Row> } styles={{ header: grayheader }}>     
            {/* register your input into the hook by invoking the "register" function */}
            <Row gutter={16}>
            <Col span={8}></Col>
            <Col span={8}>
            <Button onClick={() => this.onLogout()}>	<FormattedMessage id="Logout" defaultMessage="Logout" /> </Button>
            </Col>
            </Row>
          </Card>
        </Col>
        <Col span={8}></Col>
        </Row>
        )
  }
}
};
export default injectIntl(LoginView);
